import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import { headApi } from "utils/headApi";
import { produce } from "immer";
import { localApi, inshaApi } from "utils/imgApi";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);
const useStyCheck = makeStyles(styleCheck);

export default function AddPacking(props) {
  const [dibbiName, setDibbiName] = React.useState("");
  const [hsncode, setHsncode] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [gst, setGst] = React.useState("");
  const [dibbiErr, setDibbiErr] = React.useState("");
  const [hsncodeErr, setHsncodeErr] = React.useState("");
  const [priceErr, setPriceErr] = React.useState("");
  const [gstErr, setGstErr] = React.useState("");
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelectErr, setSimpleSelectErr] = React.useState("");

  const [newPacking, setNewPacking] = React.useState(false);

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [btn, setBtn] = React.useState(false);

  const [items, setItems] = React.useState([]);
  const [active, setActive] = React.useState(false);
  const firstRender = useRef(true);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [newDefChild, setNewDefChild] = React.useState(false);
  const [multipleSelectErr, setMultipleSelectErr] = React.useState("");

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();
  const classCheck = useStyCheck();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const handleSimple = async (event) => {
    const { value } = event.target;
    setSimpleSelect(value);
    setSimpleSelectErr("");

    const api =
      inshaApi + `/packingmaterial/list/byAdminIdAndType/2/${value}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult);

  };

  const handleMultiple = event => {
    setMultipleSelect(event.target.value);
    setMultipleSelectErr("")
  };

  const handlePkgdesc = (index) => (e) => {
    let pkgdesc = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].pkgdesc = pkgdesc;
      })
    );
  };

  const handleHsncode = (index) => (e) => {
    let hsncode = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].hsncode = hsncode;
      })
    );
  };

  const handlePrice = (index) => (e) => {
    let price = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].price = price;
      })
    );
  };

  const handleGst = (index) => (e) => {
    let ligst = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].ligst = ligst;
      })
    );
  };

  const SubmitAddDefaultPacking = (e) => {
    setNewDefChild(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Packing Type");
    }
    if (!Array.isArray(multipleSelect) || multipleSelect.length < 2) {
      errorCount++;
      setMultipleSelectErr("Select at least two Product Packing");
    }
    if (errorCount === 0) {
      // console.log(simpleSelect);
      // console.log(multipleSelect.map((m) => {
      //   return {
      //     type: m.type,
      //     pkgdesc: m.pkgdesc,
      //     hsncode: m.hsncode,
      //     price: m.price,
      //     ligst: m.ligst,
      //   }
      // }));

      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(multipleSelect.map((m) => {
          return {
            type: m.type,
            pkgdesc: m.pkgdesc,
            hsncode: m.hsncode,
            price: m.price,
            ligst: m.ligst,
          }
        })),
      };
      fetch(localApi + `/packingmaterial/addAll/${userObj.id}`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  }

  const SubmitAddPacking = () => {
    setNewPacking(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Packing Type");
    }
    if (dibbiName === "" || !dibbiName) {
      errorCount++;
      setDibbiErr("Material Name is Required");
    }
    if (hsncode === "" || !hsncode) {
      errorCount++;
      setHsncodeErr("HSN Code is Required");
    }

    if (price === "" || !price) {
      errorCount++;
      setPriceErr("Price is Required");
    }

    if (gst === "" || !gst) {
      errorCount++;
      setGstErr("GST is Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({
          type: simpleSelect,
          pkgdesc: dibbiName,
          hsncode: hsncode,
          price: price,
          ligst: gst,
        }),
      };

      fetch(
        localApi + `/packingmaterial/add/${userObj && userObj.id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false; // skip first render
      return;
    }
    // console.log("Value Changed")
    setActive(false);
    // setSimpleSelect1("");
    setMultipleSelect([]);
  }, [simpleSelect]);

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={active === true ? 12 : 12} md={active === true ? 12 : 6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Add Packing Material</small>
                {active === true ? newDefChild === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectErr || multipleSelectErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Enter Packing Type
                  </small>
                ) : newPacking === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectErr ||
                      dibbiErr ||
                      hsncodeErr ||
                      priceErr ||
                      gstErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Select Packing Type
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >Added Packing Material</SweetAlert>
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Packing Type...
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Packing Type...
                      </MenuItem>

                      <MenuItem
                        classes={{
                          root: classe.selectMenuItem,
                          selected: classe.selectMenuItemSelected,
                        }}
                        value="Crystal Dibbi"
                      >
                        Crystal Dibbi
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classe.selectMenuItem,
                          selected: classe.selectMenuItemSelected,
                        }}
                        value="Plastic Dibbi"
                      >
                        Plastic Dibbi
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classe.selectMenuItem,
                          selected: classe.selectMenuItemSelected,
                        }}
                        value="Polythene Bag"
                      >
                        Polythene Bag
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
                {active === false ? <>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Material Name..."
                      id="dibbiName"
                      inputProps={{
                        placeholder: "Ex. 2 pcs...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="dibbiName"
                      value={dibbiName}
                      onChange={(e) => {
                        setDibbiName(e.target.value);
                        setDibbiErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{dibbiErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="HSN Code..."
                      id="hsncode"
                      inputProps={{
                        placeholder: "Ex. 39202020...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="hsncode"
                      value={hsncode}
                      onChange={(e) => {
                        setHsncode(e.target.value);
                        setHsncodeErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{hsncodeErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Price..."
                      id="price"
                      inputProps={{
                        placeholder: "Ex. 0.75...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="price"
                      value={price}
                      onChange={(e) => {
                        setPrice(e.target.value);
                        setPriceErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{priceErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Tax Rate..."
                      id="gst"
                      inputProps={{
                        placeholder: "Ex. 18...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="gst"
                      value={gst}
                      onChange={(e) => {
                        setGst(e.target.value);
                        setGstErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{gstErr}</span> */}
                  </GridItem>
                </> : ""}

                <GridItem xs={12} sm={12} md={12}>
                  <FormControlLabel
                    classes={{
                      root: classCheck.checkboxLabelControl,
                      label: classCheck.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        id="active"
                        value={active}
                        checked={
                          active & (active === true) ? active : active
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setActive(checked);
                          if (!checked) {
                            // If checkbox is unchecked, clear multipleSelect
                            setMultipleSelect([]);
                            setMultipleSelectErr(""); // Also clear any errors if needed
                          }
                        }}
                        tabIndex={-1}
                        checkedIcon={
                          <Check className={classCheck.checkedIcon} />
                        }
                        icon={
                          <Check className={classCheck.uncheckedIcon} />
                        }
                        classes={{
                          checked: classCheck.checked,
                          root: classCheck.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span style={{ color: "#9c27b0" }}>
                        Would you like to save the default Packing Material?
                      </span>
                    }
                  />
                </GridItem>

                {active === true ?
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classe.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="multiple-select"
                        className={classe.selectLabel}
                      >
                        Select Material Name...
                      </InputLabel>
                      <Select
                        multiple
                        value={multipleSelect}
                        onChange={handleMultiple}
                        MenuProps={{ className: classe.selectMenu }}
                        classes={{ select: classe.select }}
                        inputProps={{
                          name: "multipleSelect",
                          id: "multiple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classe.selectMenuItem
                          }}
                        >
                          Select Material Name...
                        </MenuItem>
                        {items &&
                          items.map((item2) => (
                            <MenuItem
                              key={item2.id}
                              value={item2}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelectedMultiple,
                              }}
                            >
                              {item2.pkgdesc}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  : ""}
              </GridContainer>
              <GridContainer>
                {multipleSelect &&
                  multipleSelect.map((Ele, index) => (
                    <GridItem xs={12} sm={6} md={4} key={Ele.id} value={Ele.id}>
                      <Card>
                        <CardBody>
                          <GridContainer>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Material Name..." + Ele.id}
                                id="dibbiName"
                                inputProps={{
                                  placeholder: "Ex. 2 pcs...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="dibbiName"
                                value={Ele.pkgdesc}
                                onChange={handlePkgdesc(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"HSN Code..."}
                                id="hsncode"
                                inputProps={{
                                  placeholder: "Ex. 39202020...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="hsncode"
                                value={Ele.hsncode}
                                onChange={handleHsncode(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Price..."}
                                id="price"
                                inputProps={{
                                  placeholder: "Ex. 0.75...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="price"
                                value={Ele.price}
                                onChange={handlePrice(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Tax Rate..."}
                                id="gst"
                                inputProps={{
                                  placeholder: "Ex. 18...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="gst"
                                value={Ele.ligst}
                                onChange={handleGst(index)}
                              />
                            </GridItem>
                          </GridContainer>
                        </CardBody>
                      </Card>
                    </GridItem>
                  ))}
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitAddPacking}
                className={classes.updateProfileButton}
              >
                Save
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Save</Button>
              ) : (
                active === true ? (
                  <Button
                    color="rose"
                    onClick={SubmitAddDefaultPacking}
                    className={classes.updateProfileButton}
                  >
                    Save Default
                  </Button>
                ) :
                  <Button
                    color="rose"
                    onClick={SubmitAddPacking}
                    className={classes.updateProfileButton}
                  >
                    Save
                  </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
